import makeStyles from '@mui/styles/makeStyles'
import { tokens } from '../styles/tokens'

// Status pokryti pokynu: leva barevna lista + jemny tint misto
// puvodni celoplosne cervene/zelene.
const useStyles: any = makeStyles(theme => ({
  invalid: {
    backgroundColor: tokens.color.error[100],
    boxShadow: `inset 3px 0 0 ${tokens.color.error[500]}`,
    border: `1px solid ${tokens.color.error[100]}`,
  },
  valid: {
    backgroundColor: tokens.color.white,
    boxShadow: `inset 3px 0 0 ${tokens.color.success[500]}`,
    border: `1px solid ${tokens.color.neutral[200]}`,
  },
}))

export const useOrderCoveredColor = () => {
  const classes = useStyles()

  return (valid: boolean) => {
    if (valid === true) {
      return classes.valid
    }
    return classes.invalid
  }
}
